import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.148 14.333a3.361 3.361 0 0 1-4.22-.465l-.475-.465a1.142 1.142 0 0 1 0-1.595l2.015-1.997a1.128 1.128 0 0 1 1.583 0 1.138 1.138 0 0 0 1.592 0l3.165-3.17a1.12 1.12 0 0 0 0-1.595 1.131 1.131 0 0 1 0-1.585l2.005-2.007a1.138 1.138 0 0 1 1.593 0l.464.475a3.373 3.373 0 0 1 .464 4.226 30.552 30.552 0 0 1-8.186 8.178Z",
  stroke: "#007F8F",
  "stroke-width": "1.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }